import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { CameraController } from './camera/CameraController'
import { InputController } from './input/InputController'
import { Level4Stars } from './models/environment/Level4Stars'
import { Platforms } from './models/environment/platforms'
import { ObstacleController } from './models/obstacles/Obstacle'
import { createTrackController } from './models/track/trackController'
import { BorderTrack } from './models/track/BorderTrack'
import { Track } from './models/track/trackBuilder'
import { useTrackPathPreloaded } from './preloadAssets'
import { StartArea } from './models/environment/StartArea'
import { PowerUpOrbs } from './models/powerups/PowerUpOrbs'
import { TrackControllerProvider } from './models/track/TrackControllerContext'
import { EndArea } from './models/environment/EndArea'
import { CollectablesController } from './models/powerups/CollectablesController'
import { BatteryEffect } from './models/character/BatteryEffect'
import { PowerUpShadows } from './models/powerups/PowerUpShadows'
import { Sky } from './Sky'
import { ParentsLandingSceneSetup } from './ParentsLandingSceneSetup'
import { PlayerController } from './models/character/playerController'
import { RunRestartBridge } from './RunRestartBridge'
import { GameResetBridge } from './GameResetBridge'
import { DebugFlyCameraControls } from './camera/DebugFlyCameraControls'
import { TunnelBoundaries } from './models/tunnel/TunnelBoundaries'
import { TunnelInside } from './models/tunnel/TunnelInside'
import { ShaderWarmup } from './ShaderWarmup'
import { store } from '../stores/store'
import { GetDebuggingDocument } from '../lib/graphql/generated/graphql'
import { DebugGuiMount } from './debug/DebugGuiMount'

// import { PerfMemoryBridge } from './debug/PerfMemoryBridge'
// import { Perf } from 'r3f-perf'

export const World = observer(function World() {
    const trackPath = useTrackPathPreloaded()
    const trackController = useMemo(
        () => createTrackController(trackPath),
        [trackPath],
    )
    const debuggingData = store.getCachedQuery(GetDebuggingDocument);

    return (
        <TrackControllerProvider controller={trackController}>
            <ParentsLandingSceneSetup />
            <RunRestartBridge />
            <GameResetBridge />
            <>
                <hemisphereLight
                    color={0xeef6ff}
                    groundColor={0x20242c}
                    intensity={1.8}
                />

                <directionalLight
                    color={0xffffff}
                    intensity={2.4}
                    position={[8, 14, 8]}
                />

                <Sky />
                <Level4Stars />

                <CameraController />
                <DebugFlyCameraControls />
                <PlayerController />

                <StartArea />
                <EndArea />
                <Track />
                <BorderTrack />
                <ShaderWarmup />
                <TunnelInside />
                <TunnelBoundaries />
                <Platforms />

                <PowerUpShadows />
                <PowerUpOrbs />
                <CollectablesController />
                <ObstacleController />

                <BatteryEffect />

                <InputController />

                {debuggingData?.debugging?.showDebugMenue && <DebugGuiMount />}
                {/* <PerfMemoryBridge />
                <Perf
                    position='bottom-left'
                    customData={{
                        value: 0,
                        name: 'Memory',
                        info: ' mb',
                        round: 1,
                    }}
                /> */}
            </>
        </TrackControllerProvider>
    )
})

